import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormBurgerSizes = ({ selectedBurger, sizesBurger, allSizes, handleSizes }) => {
  const sizesMap = Object.fromEntries(sizesBurger.map((s) => [s.size_id, s]));

  const defaultValues = {
    sizes: allSizes.map((size) => {
      const exists = !!sizesMap[size.id];
      return {
        size_id: size.id,
        size_short_desc: size.size_short_desc,
        checked: exists,
        base_price: exists ? sizesMap[size.id].base_price : "",
        extra_cheese_price: exists ? sizesMap[size.id].extra_cheese_price : "",
      };
    }),
  };

  const { register, handleSubmit, watch, setValue, control } = useForm({
    defaultValues,
  });

  const { fields } = useFieldArray({
    control,
    name: "sizes",
  });

  const watchedSizes = watch("sizes");

  useEffect(() => {
    watchedSizes.forEach((item, idx) => {
      if (!item.checked) {
        setValue(`sizes.${idx}.base_price`, "");
        setValue(`sizes.${idx}.extra_cheese_price`, "");
      }
    });
  }, [watchedSizes, setValue]);

  const onSubmit = (data) => {
    const allSizes = data.sizes.map((s) => ({
      ...s,
      burger_type: selectedBurger.id,
    }));
    handleSizes(allSizes);
  };

  return (
    <div className="container">
      <div className="burger-sizes-container mx-auto">
        <h4 className="text-center fw-bold products-title mb-4">
          Hamburguesa {selectedBurger.type_description}
        </h4>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Disponible</th>
                  <th>Tamaño</th>
                  <th>Precio base</th>
                  <th>Precio extra queso</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, idx) => (
                  <tr key={field.id}>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        {...register(`sizes.${idx}.checked`)}
                        defaultChecked={field.checked}
                      />
                    </td>
                    <td>{field.size_short_desc}</td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        {...register(`sizes.${idx}.base_price`, {
                          required: watchedSizes[idx]?.checked,
                        })}
                        disabled={!watchedSizes[idx]?.checked}
                        placeholder="Base price"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        {...register(`sizes.${idx}.extra_cheese_price`, {
                          required: watchedSizes[idx]?.checked,
                        })}
                        disabled={!watchedSizes[idx]?.checked}
                        placeholder="Extra cheese price"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button type="submit" className="btn products-btn  w-100 mt-3">
            Guardar
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormBurgerSizes;
